import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c1efa5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-place" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleCardByPlace = _resolveComponent("ScheduleCardByPlace")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEvents(), (event) => {
      return (_openBlock(), _createElementBlock("div", {
        key: event.id
      }, [
        _createVNode(_component_ScheduleCardByPlace, {
          id: event.id,
          hour: event.hour,
          title: event.title,
          image: event.image,
          class: "card",
          onClick: ($event: any) => (_ctx.routeChoice(event))
        }, null, 8, ["id", "hour", "title", "image", "onClick"])
      ]))
    }), 128))
  ]))
}